// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import templateConst from 'app/common/lib/templateConst';
import { Box, Container, Icon, Text } from 'gestalt';

type HeaderType = 'protected' | 'secret' | 'archived';

type Props = {|
  type: HeaderType,
|};

const getTitle = (type: HeaderType) => {
  switch (type) {
    case 'protected':
      return i18n._('Protected boards');
    case 'secret':
      return i18n._('Secret boards');
    case 'archived':
      return i18n._('Archived boards', 'title for archived boards section on a profile');
    default:
      return '';
  }
};

const getIcon = (type: HeaderType) => (type === 'archived' ? 'remove' : 'lock');

const getDescription = (type: HeaderType) => {
  switch (type) {
    case 'protected':
      return i18n._(
        'Protected boards are not shown on your profile page publicly but anyone with the URL can view them.',
      );
    case 'secret':
      return i18n._('Only you and people you invite can see these boards. ');
    case 'archived':
      return i18n._(
        'These are hidden from your profile.',
        'subtitle for archived boards section on a profile',
      );
    default:
      return '';
  }
};

export default function ProfileBoardsGroupHeader({ type }: Props) {
  return (
    <Container>
      <Box paddingY={6} paddingX={3}>
        <Text size="sm" weight="bold">
          {getTitle(type)}{' '}
          <Icon accessibilityLabel="" color="darkGray" icon={getIcon(type)} inline size={12} />
        </Text>
        <Text inline size="sm">
          {getDescription(type)}
        </Text>
        {type === 'secret' && (
          <NavigateLink
            className="underlineLink"
            to={templateConst.settings.HELP_BOARDS_SECRET_URL_SRC_PROFILE}
            useNewTab
          >
            <Text inline size="sm" weight="bold">
              {i18n._('Learn more')}
            </Text>
          </NavigateLink>
        )}
      </Box>
    </Container>
  );
}
